export default {
  options: 'options',
  state: {
    selectedKey: 'selectedKey',
    ascending: 'ascending',
    onOptionSelect: { $call: 'changeSort' },
  },
};
